var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"dark":""}},[_c('notification'),_vm._v(" "),_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }